export enum PaymentParty {
    Student = 1,
    FlightSchool = 2
}